import Axios from "axios";
import ApiUtils from "../utils/api_utils";

const API_URL = `https://${ApiUtils.authority}`;
const FeedsSM = {
  state: {
    feedDataDashboard: [],
    feedData: [],
    feedDetail: {},
    totalComment: 0,
    listComment: [],
    dataAllLike: [],
    loading: false,
  },
  reducers: {
    setFeedState(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getFeeds(page = 1, rootState) {
      let result;
      await Axios.get(`${API_URL}/feeds/api/list/?page=${page}`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then((response) => {
          result = {
            data: response.data.results,
            status: 200,
            message: "success",
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async getFeedsDetail(id, rootState) {
      let result;
      await Axios.get(`${API_URL}/feeds/api/list/${id}/`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then((response) => {
          // this.getComment(id);
          dispatch.FeedsSM.setFeedState({
            // ...rootState.FeedsSM,
            feedDetail: response.data,
          });
          result = {
            data: response.data,
            status: 200,
            message: "success",
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async getComment(id, rootState) {
      let result;
      await Axios.get(`${API_URL}/feeds/api/comments/?feed=${id}`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then((response) => {
          dispatch.FeedsSM.setFeedState({
            // ...rootState.FeedsSM,
            totalComment: response.data.count,
            listComment: response.data.results,
          });
          result = {
            data: response.data,
            status: 200,
            message: "success",
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async getAllLike(id, rootState) {
      let result;
      await Axios.get(`${API_URL}/feeds/api/${id}/likes/`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then((response) => {
          // this.getFeedsDetail(id);

          dispatch.FeedsSM.setFeedState({
            dataAllLike: response.data.results,
          });
          result = {
            data: response.data,
            status: 200,
            message: "success",
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async postLike(id, rootState) {
      let result;
      await Axios.post(
        `${API_URL}/feeds/api/${id}/likes/?id=${id}`,
        {},
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then((response) => {
          this.getFeedsDetail(id);
          this.getAllLike(id);
          result = {
            data: response.data,
            status: 200,
            message: "success",
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async deleteLike({ id, idLike }, rootState) {
      let result;
      await Axios.delete(`${API_URL}/feeds/api/like/${idLike}/`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then((response) => {
          this.getFeedsDetail(id);
          this.getAllLike(id);
          result = {
            data: response.data,
            status: 200,
            message: "success",
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async postBookmark(id, rootState) {
      let result;
      await Axios.post(
        `${API_URL}/feeds/api/favorites/`,
        {
          feed: id,
        },
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then((response) => {
          this.getFeedsDetail(id);
          result = {
            data: response.data,
            status: 200,
            message: "success",
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async deleteBookmark({ id, idFavorite }, rootState) {
      let result;
      await Axios.delete(`${API_URL}/feeds/api/favorites/${idFavorite}/`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then((response) => {
          this.getFeedsDetail(id);
          result = {
            data: response.data,
            status: 200,
            message: "success",
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async postComment(payload, rootState) {
      const { id, text, idParent } = payload;
      let formData = { text };
      if (idParent) formData.parent = idParent;
      let result;
      await Axios.post(`${API_URL}/feeds/api/comments/?feed=${id}`, formData, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then((response) => {
          this.getComment(id);
          result = {
            data: response.data,
            status: 200,
            message: "success",
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async initFeeds(payload, rootState) {
      let endpoints = [
        `${API_URL}/feeds/api/list/dashboard/`,
        `${API_URL}/feeds/api/list/`,
      ];

      Promise.all(
        endpoints.map((endpoint) =>
          Axios.get(endpoint, {
            headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
            withCredentials: false,
          })
        )
      ).then(([{ data: feedDataDashboard }, { data: feedData }]) => {
        dispatch.FeedsSM.setFeedState({
          // ...rootState.FeedsSM,
          feedDataDashboard,
          feedData: feedData.results,
        });
      });
    },
  }),
};

export default FeedsSM;
